// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"60":"1e0e4573","156":"68570e1d","462":"655b1880"}[chunkId] + ".chunk.css";
};